"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineStatusLabel = void 0;
const getOrderLineStatusLabel = (item) => {
    switch (item.status) {
        case "PENDING":
            return {
                label: "Pending",
                className: "text-blue text-15 font-semibold",
            };
        case "URGENT_ACTION_REQUIRED":
            return {
                label: "Urgent action required",
                className: "text-orange text-15 font-semibold",
            };
        case "WAITING_TO_SEND":
            return {
                label: "Waiting to send",
                className: "text-orange text-15 font-semibold",
            };
        case "MISSING_SUPPLIER_EMAIL":
            return {
                label: "Missing supplier email",
                className: "text-red text-15 font-semibold",
            };
        case "WAITING_FOR_SUPPLIER":
            return {
                label: "Waiting for supplier",
                className: "text-orange text-15 font-semibold",
            };
        case "CONFIRMED":
            return {
                label: "Confirmed",
                className: "text-green text-15 font-semibold",
            };
        case "ALTERNATIVE_OFFERED":
            return {
                label: "Alternative offered",
                className: "text-blue text-15 font-semibold",
            };
        case "ALTERNATIVE_OFFERED_OVERDUE":
            return {
                label: "Alternative offered overdue",
                className: "text-red text-15 font-semibold",
            };
        case "CANCELLED":
            return {
                label: "Cancelled",
                className: "text-black90 text-15 font-semibold",
            };
        case "CANCELLED_UNAVAILABLE":
            return {
                label: "Cancelled - unavailable",
                className: "text-black90 text-15 font-semibold",
            };
        case "CANCELLED_REJECTED":
            return {
                label: "Cancelled - rejected",
                className: "text-black90 text-15 font-semibold",
            };
        case "WAITING_FOR_SUPPLIER_OVERDUE":
            return {
                label: "Waiting for supplier overdue",
                className: "text-red text-15 font-semibold",
            };
    }
};
exports.getOrderLineStatusLabel = getOrderLineStatusLabel;
